import {
  GET_USERS,
  GET_USERS_SUCCESS,
  API_ERROR,
  GET_USERS_BY_ROLE,
  GET_USERS_BY_ROLE_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_CLEAN,
  SEND_USER_TRASH,
  SEND_USER_TRASH_SUCCESS,
  SEND_USER_TRASH_ERROR,
  SEND_USER_TRASH_CLEAN,
  RESTORE_USER,
  RESTORE_USER_SUCCESS,
  RESTORE_USER_ERROR,
  RESTORE_USER_CLEAN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  changePasswordLoading: false,
  changePasswordSuccess: false,
  changePasswordError: "",
  done: false,
  trashDone: false,
  restoreDone: false,
  users: [],
  usersByRole: [],
}

const UsersList = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_USERS_SUCCESS:
      state = {
        ...state,
        users: action.payload.users,
        loading: false,
        done: true,
      }
      break
    case GET_USERS_BY_ROLE:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_USERS_BY_ROLE_SUCCESS:
      state = {
        ...state,
        usersByRole: action.payload.users,
        loading: false,
        done: true,
      }
      break
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changePasswordLoading: true,
      }
      break
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changePasswordError: "",
        changePasswordLoading: false,
        changePasswordSuccess: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    case CHANGE_PASSWORD_ERROR:
      state = {
        ...state,
        changePasswordError: action.payload,
        changePasswordLoading: false,
        changePasswordSuccess: false,
      }
      break
    case CHANGE_PASSWORD_CLEAN:
      state = {
        ...state,
        changePasswordLoading: false,
        changePasswordSuccess: false,
        changePasswordError: "",
      }
      break
    case SEND_USER_TRASH:
      state = {
        ...state,
        loading: true,
        trashDone: false,
      }
      break
    case SEND_USER_TRASH_SUCCESS:
      state = {
        ...state,
        loading: false,
        trashDone: true,
      }
      break
    case SEND_USER_TRASH_ERROR:
      state = {
        ...state,
        loading: false,
        trashDone: false,
      }
      break
    case SEND_USER_TRASH_CLEAN:
      state = {
        ...state,
        loading: false,
        trashDone: false,
      }
      break
    case RESTORE_USER:
      state = {
        ...state,
        loading: true,
        restoreDone: false,
      }
      break
    case RESTORE_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        restoreDone: true,
      }
      break
    case RESTORE_USER_ERROR:
      state = {
        ...state,
        loading: false,
        restoreDone: false,
      }
      break
    case RESTORE_USER_CLEAN:
      state = {
        ...state,
        loading: false,
        restoreDone: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default UsersList
